import React from 'react';

const FormAttachment = (props) => {
    const { formObject, action, headerKey, rowKey, className, imgHeight, imgStyle } = props;

    //generate large image Link
    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const src = formObject.getValueFromKey(viewData, "dataList.src", "");

    if (src && hide === "0") {
        if(action.InputType === "i"){
            const lsrc = formObject.getValueFromKey(viewData, "dataList.lsrc", "");

            return (
                <a href={lsrc} target="_LargeImage">
                    <img alt="" height={imgHeight} style={imgStyle} src={src} 
                      onError={e => { e.target.style.display = 'none'; }}
                    />
                </a>
            )
        }
        else if(action.InputType === "a"){
            return(
                <a className={className || "uiLink"} href={src} target="_OpenFile">{viewData.valF}</a>
            )
        }
    }

    return (
            null
        )
}

export default FormAttachment